import { Box, Divider, Paper, Stack, Typography } from '@mui/material';
import { DefinitionList, designTokens } from '../../../design-system';
import { previewParts } from '../model/employeeNumber';

type EmployeeNumberPreviewProps = {
  preview: ReturnType<typeof previewParts>;
};

export function EmployeeNumberPreview({ preview }: EmployeeNumberPreviewProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        overflow: 'hidden',
        position: {
          lg: 'sticky',
        },
        top: {
          lg: 16,
        },
      }}
    >
      <Box
        sx={{
          p: 2.25,
          bgcolor: designTokens.color.actionSoft,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: designTokens.color.actionDark,
            fontWeight: 750,
            letterSpacing: '0.08em',
          }}
        >
          사번 형식 예시
        </Typography>
        <Stack
          data-testid="employee-number-preview"
          aria-live="polite"
          direction="row"
          sx={{
            mt: 2,
            alignItems: 'baseline',
            overflowX: 'auto',
            fontFamily: '"SFMono-Regular", Consolas, "Liberation Mono", monospace',
            fontSize: {
              xs: 30,
              sm: 36,
            },
            lineHeight: 1.1,
            fontWeight: 760,
            letterSpacing: '0.015em',
          }}
        >
          <Box
            component="span"
            sx={{
              color: designTokens.color.success,
            }}
          >
            {preview.prefix}
          </Box>
          <Box
            component="span"
            sx={{
              color: designTokens.color.primaryText,
            }}
          >
            {preview.date}
          </Box>
          <Box
            component="span"
            sx={{
              color: designTokens.color.action,
            }}
          >
            {preview.sequence}
          </Box>
        </Stack>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mt: 1.25,
            lineHeight: 1.65,
          }}
        >
          현재 날짜와 첫 번째 순번을 넣은 예시입니다. 실제 순번은 이미 발급된 사번과 승인 대기 중인 입사 초안을 이어서
          계산합니다.
        </Typography>
      </Box>
      <Divider />
      <Box
        sx={{
          p: 2,
        }}
      >
        <DefinitionList
          items={[
            ['접두어', preview.prefix || '없음'],
            ['날짜', preview.date || '없음'],
            ['순번', preview.sequence],
          ]}
        />
      </Box>
    </Paper>
  );
}
